export default __webpack_public_path__ + "static/media/ash.86a0021c.png";